import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";

function AdminDashboard() {
  const [dashboardData, setDashboardData] = useState({
    totalUserCount: 0,
    activeUserCount: 0,
    expiredUserCount: 0,
    newUserCount: 0, // If you have logic for "new" (e.g., created this month), calculate it
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const response = await axiosInstance.get("/admin/api/dashboard/superadmin");
        if (response.data.Status === 1) {
          const counts = response.data.data.counts;
          setDashboardData({
            totalUserCount: counts.totalUserCount,
            activeUserCount: counts.activeUserCount,
            expiredUserCount: counts.expiredUserCount,
            newUserCount: counts.newUserCount,
          });
        }
      } catch (err) {
        setError("Failed to load dashboard data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  if (loading) return <div>Loading dashboard...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <div className="App container mt-4">
        <h3 className="mb-4">Super Admin Dashboard</h3>
        <div className="row">
          {/* New User Card */}
          <div className="col-md-3">
            <div>
              <div className="card-bg h-50 w-100">
                <h5 className="">New User</h5>
                <p className="card-text fs-3">{dashboardData.newUserCount}</p>
              </div>
            </div>
          </div>

          {/* Active Users Card */}
          <div className="col-md-3">
            <div>
              <div className="card-bg h-50 w-100">
                <h5>Active Users</h5>
                <p className="card-text fs-3">{dashboardData.activeUserCount}</p>
              </div>
            </div>
          </div>

          {/* Expired User Card */}
          <div className="col-md-3">
            <div>
              <div className="card-bg h-50 w-100">
                <h5>Expired User</h5>
                <p className="card-text fs-3">{dashboardData.expiredUserCount}</p>
              </div>
            </div>
          </div>
          {/* Total User Card */}
          <div className="col-md-3">
            <div>
              <div className="card-bg h-50 w-100">
                <h5>Total User</h5>
                <p className="card-text fs-3">{dashboardData.totalUserCount}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminDashboard;